export class DomesticRoadTransportOrder {
    public id:number|null;
    public series:string;
    public oneclick_order_number:string;
    public no_need_uit:boolean;
    public incoterm_name:string;
    public incoterm_city:string;
    public incoterm_country_id:number;
    public uit_code:string;
    public klg_transport_organizer:boolean;
    public speed_delivery:boolean;
    public loading_contact_email:string;
    public loading_reference:string;
    public loading_features:number[];
    public unloading_contact_email:string;
    public unloading_reference:string;
    public unloading_features:number[];

    constructor(data:DomesticRoadTransportOrderData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.series = "";
            this.oneclick_order_number = "";
            this.incoterm_name = "";
            this.incoterm_city = "";
            this.incoterm_country_id = 0;
            this.uit_code = "";
            this.klg_transport_organizer = false;
            this.no_need_uit = false;
            this.speed_delivery = false;
            this.loading_contact_email = "";
            this.loading_reference = "";
            this.loading_features = [];
            this.unloading_contact_email = "";
            this.unloading_reference = "";
            this.unloading_features = [];
        }
        else
        {
            this.id = data.id;
            this.series = data.series;
            this.oneclick_order_number = data.oneclick_order_number;
            this.series = data.series;
            this.oneclick_order_number = data.oneclick_order_number;
            this.incoterm_name = data.incoterm_name;
            this.incoterm_city = data.incoterm_city;
            this.incoterm_country_id = data.incoterm_country_id;
            this.uit_code = data.uit_code;
            this.klg_transport_organizer = data.klg_transport_organizer;
            this.no_need_uit = data.no_need_uit;
            this.speed_delivery = data.speed_delivery;
            this.loading_contact_email = data.loading_contact_email;
            this.loading_reference = data.loading_reference;
            this.loading_features = data.loading_features;
            this.unloading_contact_email = data.unloading_contact_email;
            this.unloading_reference = data.unloading_reference;
            this.unloading_features = data.unloading_features;
        }
    }
}

export type DomesticRoadTransportOrderData = {
    id:number|null;
    series:string;
    oneclick_order_number:string;
    incoterm_name:string;
    incoterm_city:string;
    incoterm_country_id:number;
    uit_code:string;
    klg_transport_organizer:boolean;
    no_need_uit:boolean;
    speed_delivery:boolean;
    loading_contact_email:string;
    loading_reference:string;
    loading_features:number[];
    unloading_contact_email:string;
    unloading_reference:string;
    unloading_features:number[];
}